import { createSelector } from 'reselect'
import { getArrayOfObjectValues } from '../../utils';

export const getSpecialDaysSelector = createSelector(
  specialday => specialday.specialday,
  (specialdaysById) => getArrayOfObjectValues(specialdaysById)
);